import { connect } from 'react-redux'

import { login } from '../actions'
import Login from '../components/Login'
import * as selectors from '../selectors'


const mapStateToProps = state => {
    return {
        logging_in: selectors.isLoggingIn(state),
        login_failed: selectors.loginFailed(state),
        token: selectors.userToken(state)
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onLogin: (username, password) => dispatch(login(username, password))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)


/** WEBPACK FOOTER **
 ** ./src/containers/LoginContainer.js
 **/